import { defineComponent as _defineComponent } from 'vue'
import type { CompactSchedule } from '@/models/CompactSchedule';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleDateRenderer',
  props: {
    item: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})